/**
 * Created by jonas on 2019-08-21.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { Linear, Power4, TimelineLite, TweenLite, TimelineMax, Back, Timeline} from "gsap";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {HarlequinGameConfig} from "../../HarlequinGameConfig";
import {HarlequinTextStyles} from "../../config/HarlequinTextStyles";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {CoinsFountain} from "../emitter/CoinsFountain";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {FadePlate} from "@nolimitcity/slot-game/bin/timelinegameround/components/FadePlate";
import {HarlequinSoundConfig} from "../../HarlequinSoundConfig";

export class WinTextView extends BaseView {
    private _winText:PIXI.Text;

    // TODO: REMOVE
    private _winSprites:PIXI.Sprite [] = [];

    private _activeSprite:PIXI.Sprite = new PIXI.Sprite();
    private _activeSpriteTimeline:TimelineMax | null;
    private _mainTl:Timeline | null;
    private _aborted:boolean = false;

    private _winTextContainer:PIXI.Container;
    private _layer:ScalableLayer;
    private _fadeLayer:ScalableLayer;
    private _currentSound:string = "";

    private _currentTimeLine:TimelineLite | null;

    private _coinsFountain: CoinsFountain;
    private _fullScreenFade:FadePlate;
    protected _screenRect:PIXI.Rectangle;

    private _starLayerTop: PIXI.Sprite;
    private _starLayerBottom: PIXI.Sprite;

    private _hueTimeline:Timeline;

    private _xScale:number = 2.5;
    private _yScale:number = 2.5;

    constructor() {
        super();
        this._layer = StageManager.getLayer(HarlequinGameConfig.instance.LAYERS.BIG_WIN.name);
        this._fadeLayer = StageManager.getLayer(HarlequinGameConfig.instance.LAYERS.BIG_WIN_FADE.name);
        this._coinsFountain = new CoinsFountain(StageManager.getLayer(HarlequinGameConfig.instance.LAYERS.BIG_WIN_CU.name));
    }

    private _hueConfs: any [] = [
        {
            start: 165,
            end: 195
        },
        {
            start: 330,
            end: 360
        },
        {
            start: 135,
            end: 165
        }
    ];
    private _activeHueId: number = 0;


    protected initAnimations():void {

        this._fullScreenFade = new FadePlate(0x000000, 1);
        this._fadeLayer.addChild(this._fullScreenFade);

        this._winText = new PIXI.Text("SUPER MEGA\nWIN", HarlequinTextStyles.BIG_WIN_TEXT);
        this._winText.anchor.set(0.5, 0.5);

        const colorMatrix = new PIXI.filters.ColorMatrixFilter();

        this._starLayerTop = new PIXI.Sprite(GameResources.getTextures("bigWinBgStar")[0]);
        this._starLayerTop.alpha = 0;
        this._starLayerTop.anchor.set(0.5, 0.5);
        this._starLayerBottom = new PIXI.Sprite(GameResources.getTextures("bigWinBgStar")[0]);
        this._starLayerBottom.alpha = 0;
        this._starLayerBottom.anchor.set(0.5, 0.5);

        this._starLayerTop.filters = [colorMatrix];
        this._starLayerBottom.filters = [colorMatrix];
        colorMatrix.hue(170, false);
        colorMatrix.blendMode = PIXI.BLEND_MODES.SCREEN;

        let cntr:number = this._hueConfs[this._activeHueId].start;
        let sub:boolean = true;

        this._hueTimeline = new TimelineMax({
            paused: true,
            repeat: -1
        });



        this._hueTimeline.add(() => {
            if(cntr > this._hueConfs[this._activeHueId].end) {
                cntr = this._hueConfs[this._activeHueId].end;
                sub = true;
            }
            if(cntr < this._hueConfs[this._activeHueId].start) {
                cntr = this._hueConfs[this._activeHueId].start;
                sub = false;
            }

            if(sub) {
                colorMatrix.hue(cntr-=2.5, false); // +=5
            }
            else {
                colorMatrix.hue(cntr+=2.5, false); // +=5
            }

        }, 0.066);



        this._winSprites.push(new PIXI.Sprite());

        this._winSprites[0].name = "lvl1";
        const spn1:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("bigWinText"));
        this._winSprites[0].addChild(spn1);
        this._activeSprite = this._winSprites[0];

        //const scale = 700 / this._winText.width;
        this._winText.scale.set(0.7, 0.7);

        this._winText.text = "";

        this._winTextContainer = new PIXI.Container();
        this._winTextContainer.position.set(630, 230);

        //this._winTextContainer.addChild(this._winText);
        this.addChild(this._starLayerBottom);
        this.addChild(this._starLayerTop);
        this.addChild(this._winTextContainer);

        this._winTextContainer.addChild(this._activeSprite);

        /*this._layer.addChild(this);
        this._starLayerTop.visible = true;
        this._starLayerBottom.visible = true;
        this._starLayerTop.alpha = 1;
        this._starLayerBottom.alpha = 1;
        this.visible = true;*/
    }

    onResize(data:IResizeData) {
        this._screenRect = new PIXI.Rectangle(0, 0, data.width / this._layer.scale.x, data.height / this._layer.scale.y);

        if(data.orientation === Orientation.PORTRAIT) {
            //const scale = 700 / this._winText.width;
            this._winText.scale.set(0.45, 0.45);
            this._winText.position.set(0, 0);

            this._activeSprite.anchor.set(0.5, 0.5);
            this._activeSprite.position.set(30, -100);

            this._fullScreenFade.resize(-100, -400, this._screenRect.width + 200, this._screenRect.height + 400);
            this._winTextContainer.position.set(340, 300);

            this._starLayerBottom.scale.set(3, 3);
            this._starLayerTop.scale.set(3, 3);

            this._xScale = 3;
            this._yScale = 3;

            this._starLayerBottom.position.set(350, 360);
            this._starLayerTop.position.set(350, 360);
        }
        else {
            const scale = 700 / this._winText.width;
            this._winText.position.set(0, 0);
            this._winText.scale.set(0.7, 0.7);
            this._activeSprite.anchor.set(0.5, 0.5);
            this._activeSprite.position.set(10,0);

            this._fullScreenFade.resize(-600, -200, this._screenRect.width + 500, this._screenRect.height + 200);
            this._winTextContainer.position.set(340, 200);

            this._starLayerBottom.scale.set(2.5, 2.5);
            this._starLayerTop.scale.set(2.5, 2.5);
            this._xScale = 2.5;
            this._yScale = 2.5;

            this._starLayerBottom.position.set(350, 390);
            this._starLayerTop.position.set(350, 390);
        }
    }

    private updateBigWinLevelAnimation(level: number): TimelineLite {
        const timeline: TimelineLite = new TimelineLite();
        /*this._texts.forEach((text: PIXI.Sprite, i: number) => {
            text.alpha = (i === level) ? 1 : 0;
        });*/

        timeline.add([
            TweenLite.fromTo(this._winTextContainer, 7 * 0.033, {alpha: 0}, {alpha: 100}),
            TweenLite.fromTo(this._winTextContainer.scale, 7 * 0.033, {x: 2, y: 2}, {x: 1, y: 1})
        ], 0);

        //this._isShowing = true;
        return timeline;
    }


    public getStartAnimation(config:IWinRatioConfig, isBigWin?:boolean, isEnd:boolean = false, level:number = 1, text?:string):TimelineLite{
        const tl:TimelineLite = new TimelineLite();


        if(isBigWin && !this._aborted) {
            tl.add([
                () => {
                    if(isEnd) {
                        if(this._activeSpriteTimeline) {
                            this._activeSpriteTimeline.pause();
                            this._activeSpriteTimeline.kill();
                            this._activeSpriteTimeline = null;
                        }
                    }
                }
            ], 0);
        }

        tl.add([
            () => {
                this._hueTimeline.play(0);
                this._fadeLayer.visible = true;
            },
            TweenLite.to(this._starLayerTop, 0.1, {alpha: 0.6}),
            TweenLite.to(this._starLayerBottom, 0.1, {alpha: 1}),
            () => {
                this.updateText(config, undefined, text);
                //this._winTextContainer.scale.set(0.5,0.5);
                //this._winTextContainer.alpha = 0.5;
                this._layer.addChild(this);
            },
            this._fullScreenFade.getFadeTo(0.1, 0.6)
        ]);

        if(level > 0) {
            tl.add([
                TweenLite.fromTo(this._starLayerTop.scale, config.duration - 0.2, {x : this._xScale, y : this._yScale},{x : this._xScale - 1.8, y : this._yScale - 1.8, ease : Power4.easeIn}),
                TweenLite.fromTo(this._starLayerBottom.scale, config.duration - 0.2, {x : this._xScale, y : this._yScale},{x : this._xScale - 1.8, y : this._yScale - 1.8, ease : Power4.easeIn})
            ], level === 1 ? "+=0.2" : "+=0");
            tl.add([
                TweenLite.fromTo(this._starLayerTop.scale, 0.2, {x : this._xScale - 1.8, y : this._yScale - 1.8},{x : this._xScale, y : this._yScale, ease : Back.easeInOut}),
                TweenLite.fromTo(this._starLayerBottom.scale, 0.2, {x : this._xScale - 1.8, y : this._yScale - 1.8}, {x : this._xScale, y : this._yScale, ease : Back.easeInOut})
            ], level === 1 ? "+=0.2" : "+=0");
        }


        tl.add([
            () => this.playWinSound(config)
        ]);


        this._mainTl = tl;
        return tl;
    }

    public getEndAnimation(config:IWinRatioConfig):TimelineLite{
        const tl:TimelineLite = new TimelineLite();

        //Hide prev text
        tl.add([
            this._fullScreenFade.getFadeOut(0.2),
            () => this.updateText(config, true),
            () => this._coinsFountain.stopFountain(),
            () => {
                if(this._activeSpriteTimeline) {
                    this._activeSpriteTimeline.pause();
                    this._activeSpriteTimeline.kill();
                    this._activeSpriteTimeline = null;
                }
            }
        ]);

        tl.add(()=>this.playWindUp(), tl.totalDuration() - 1.5);

        return tl;
    }




    public abort(config:IWinRatioConfig):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        this._aborted = true;

        if(config.text == undefined || config.text == "") {
            return tl;
        }

        if(this._activeSpriteTimeline) {
            this._activeSpriteTimeline.pause();
            this._activeSpriteTimeline.kill();
            this._activeSpriteTimeline = null;
        }

        if(this._mainTl) {
            this._mainTl.pause();
            this._mainTl.kill();
            this._mainTl = null;
        }

        tl.add(() => {
            this.playWinSound(config);
            this.updateText(config);
            this._layer.addChild(this);
            this._winTextContainer.scale.set(1, 1);
            this._winTextContainer.rotation = 0;
            this._winTextContainer.alpha = 1;
            this._coinsFountain.stopFountain();
            if( this._currentTimeLine && this._currentTimeLine.isActive()){
                this._currentTimeLine.pause();
                this._currentTimeLine.kill();
            }
            this._currentTimeLine = null;
            this._aborted = false;
        }, 0.001);

        return tl;
    }

    public end(config:IWinRatioConfig, displayDuration:number, fadeOutDuration:number, isBigWin:boolean = false):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            this._currentSound = "";
        });
        //tl.add(this.getStartAnimation(config, isBigWin, true));
        tl.add( [
            TweenLite.fromTo(this._starLayerTop.scale, 0.2, {x : this._xScale - 1.8, y : this._yScale - 1.8, ease : Back.easeInOut},{x : this._xScale, y : this._yScale, ease : Back.easeInOut}),
            TweenLite.fromTo(this._starLayerBottom.scale, 0.2, {x : this._xScale - 1.8, y : this._yScale - 1.8, ease : Back.easeInOut}, {x : this._xScale, y : this._yScale, ease : Back.easeInOut})
        ]);
        tl.add(() => this.fadeAndRemove(fadeOutDuration), displayDuration);
        tl.add(() => this.cleanup());
        return tl;
    }


    private updateText(config:IWinRatioConfig, end:boolean = false, text?:string) {
        this._winText.text = config.text ? config.text : "";

        if (text) {
            switch (text) {
                case "Big Win":
                    this._activeHueId = 0;
                    this._currentTimeLine = new TimelineLite();
                    this._currentTimeLine.to(this._starLayerTop, 300, {rotation: -360, repeat: 3, repeatDelay: 0.5}, 0);
                    this._currentTimeLine.to(this._starLayerBottom, 300, {
                        rotation: 360,
                        repeat: 3,
                        repeatDelay: 0.5
                    }, 0);

                    const sprite: PIXI.Sprite = this._activeSprite;
                    const spn: PIXI.spine.Spine = <PIXI.spine.Spine>sprite.getChildAt(0);
                    sprite.visible = true;

                    if (!end) {
                        SlotGame.sound.playEffect(HarlequinSoundConfig.instance.BIG_WIN_LEVEL_1);
                        this._layer.alpha = 0;
                        SlotGame.sound.fadeAmbience(0, 536);
                        new TweenLite(this._layer, 0.436, {
                            alpha: 1,
                            ease: Linear.easeNone
                        }).eventCallback("onComplete", () => {
                            spn.state.setAnimation(0, "fantastico", false);
                            this._coinsFountain.startFountain(0);
                        });
                    } else {
                        if (this._aborted) {
                            spn.state.setAnimation(0, "fantastico", false);
                        }
                    }
                    break;
                case "Mega Win":
                    this._activeHueId = 1;
                    if (!this._currentTimeLine) {
                        this._currentTimeLine = new TimelineLite();
                        this._currentTimeLine.to(this._starLayerTop, 300, {
                            rotation: -360,
                            repeat: 3,
                            repeatDelay: 0.5
                        }, 0);
                        this._currentTimeLine.to(this._starLayerBottom, 300, {
                            rotation: 360,
                            repeat: 3,
                            repeatDelay: 0.5
                        }, 0);
                    }

                    const sprite2: PIXI.Sprite = this._activeSprite;
                    const spn2: PIXI.spine.Spine = <PIXI.spine.Spine>sprite2.getChildAt(0);

                    sprite2.visible = true;
                    spn2.state.setAnimation(0, "magnifico", false);
                    this._coinsFountain.startFountain(1);

                    break;
                case "Super Mega Win":
                    this._activeHueId = 2;
                    if (!this._currentTimeLine) {
                        this._currentTimeLine = new TimelineLite();
                        this._currentTimeLine.to(this._starLayerTop, 300, {
                            rotation: -360,
                            repeat: 3,
                            repeatDelay: 0.5
                        }, 0);
                        this._currentTimeLine.to(this._starLayerBottom, 300, {
                            rotation: 360,
                            repeat: 3,
                            repeatDelay: 0.5
                        }, 0);
                    }

                    const sprite3: PIXI.Sprite = this._activeSprite;
                    const spn3: PIXI.spine.Spine = <PIXI.spine.Spine>sprite3.getChildAt(0);

                    sprite3.visible = true;
                    //sprite3.removeChildAt(0);
                    //sprite3.addChild(spn3);
                    spn3.state.setAnimation(0, "miracolo", false);
                    //this._activeSprite = sprite2;
                    this._coinsFountain.startFountain(2);
                    break;
                default:
                    this._activeSprite.visible = false;
                    break;
            }
        }
        else {
            switch (config.text) {
                case "Big Win":
                    this._activeHueId = 0;
                    this._currentTimeLine = new TimelineLite();
                    this._currentTimeLine.to(this._starLayerTop, 300, {rotation: -360, repeat: 3, repeatDelay: 0.5}, 0);
                    this._currentTimeLine.to(this._starLayerBottom, 300, {
                        rotation: 360,
                        repeat: 3,
                        repeatDelay: 0.5
                    }, 0);

                    const sprite: PIXI.Sprite = this._activeSprite;
                    const spn: PIXI.spine.Spine = <PIXI.spine.Spine>sprite.getChildAt(0);
                    sprite.visible = true;

                    if (!end) {
                        SlotGame.sound.playEffect(HarlequinSoundConfig.instance.BIG_WIN_LEVEL_1);
                        this._layer.alpha = 0;
                        SlotGame.sound.fadeAmbience(0, 536);
                        new TweenLite(this._layer, 0.436, {
                            alpha: 1,
                            ease: Linear.easeNone
                        }).eventCallback("onComplete", () => {
                            spn.state.setAnimation(0, "fantastico", false);
                            this._coinsFountain.startFountain(0);
                        });
                    } else {
                        if (this._aborted) {
                            spn.state.setAnimation(0, "fantastico", false);
                        }
                    }
                    break;
                case "Mega Win":
                    this._activeHueId = 1;
                    if (!this._currentTimeLine) {
                        this._currentTimeLine = new TimelineLite();
                        this._currentTimeLine.to(this._starLayerTop, 300, {
                            rotation: -360,
                            repeat: 3,
                            repeatDelay: 0.5
                        }, 0);
                        this._currentTimeLine.to(this._starLayerBottom, 300, {
                            rotation: 360,
                            repeat: 3,
                            repeatDelay: 0.5
                        }, 0);
                    }

                    const sprite2: PIXI.Sprite = this._activeSprite;
                    const spn2: PIXI.spine.Spine = <PIXI.spine.Spine>sprite2.getChildAt(0);

                    sprite2.visible = true;
                    spn2.state.setAnimation(0, "magnifico", false);
                    this._coinsFountain.startFountain(1);

                    break;
                case "Super Mega Win":
                    this._activeHueId = 2;
                    if (!this._currentTimeLine) {
                        this._currentTimeLine = new TimelineLite();
                        this._currentTimeLine.to(this._starLayerTop, 300, {
                            rotation: -360,
                            repeat: 3,
                            repeatDelay: 0.5
                        }, 0);
                        this._currentTimeLine.to(this._starLayerBottom, 300, {
                            rotation: 360,
                            repeat: 3,
                            repeatDelay: 0.5
                        }, 0);
                    }

                    const sprite3: PIXI.Sprite = this._activeSprite;
                    const spn3: PIXI.spine.Spine = <PIXI.spine.Spine>sprite3.getChildAt(0);

                    sprite3.visible = true;
                    //sprite3.removeChildAt(0);
                    //sprite3.addChild(spn3);
                    spn3.state.setAnimation(0, "miracolo", false);
                    //this._activeSprite = sprite2;
                    this._coinsFountain.startFountain(2);
                    break;
                default:
                    this._activeSprite.visible = false;
                    break;
            }
        }
    }

    private fadeAndRemove(duration:number) {
        const tl:TimelineLite = new TimelineLite();


        tl.add([
           // new TweenLite(this._winTextContainer.scale, duration, {x : 0, y : 0, ease : Power2.easeIn}),
            new TweenLite(this._winTextContainer, duration, {alpha : 0, ease : Linear.easeNone}),
            () => {
                this._hueTimeline.pause();
            },
        ]);
        tl.add(() => {
            TweenLite.to(this._starLayerTop, 1, {alpha: 0});
            TweenLite.to(this._starLayerBottom, 1, {alpha: 0});
            this._coinsFountain.stopFountain();
            this._layer.removeChild(this);
            this._fadeLayer.visible = false;
            this._winTextContainer.alpha = 1;

            const sprite:PIXI.Sprite = this._activeSprite;
            const spn:PIXI.spine.Spine =  <PIXI.spine.Spine> sprite.getChildAt(0);
            spn.state.setEmptyAnimation(0, 0)
        });
        return tl;
    }

    private cleanup() {
        this._winText.text = "";
    }


    private playWinSound(config:IWinRatioConfig){
        let newSound:string = "";
        //FixMe - Jonas removed. Needed?
  /*      if (config.sound){
            newSound = config.sound;
        }
*/
        if (this._currentSound != newSound){
            if (this._currentSound != ""){
                SlotGame.sound.stopEffect(this._currentSound);
            }
            SlotGame.sound.playEffect(newSound,0);
            this._currentSound = newSound;
        }
    }


    private playWindUp() {

    }
}